// Migrated 1:1 from @nexato/nx-core-module (lib/components/relative-time.component.ts), #672.
import { Component, input, computed } from '@angular/core';
import { ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'app-relative-time',
    template: `<span [pTooltip]="exactTime()" tooltipPosition="top">{{ timestamp() | formatRelativeTime }}</span>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelativeTimeComponent {
    readonly timestamp = input<string>();

    readonly exactTime = computed(() => {
        const ts = this.timestamp();
        if (!ts) return '';
        return moment(ts).format('DD.MM.YYYY HH:mm') + ' Uhr';
    });
}
